import L from 'leaflet';

export const EVENT_ID_FIELD = "e_id";
export const EVENT_SOURCE_FIELD = "e_source";
export const EVENT_STAGE_FIELD = "e_stage";
export const EVENT_GEN_DATE_FIELD = "e_gen_ts";
export const EVENT_RCV_DATE_FIELD = "e_rcv_ts";
export const EVENT_LONG_FIELD = "e_pos_long";
export const EVENT_LAT_FIELD = "e_pos_lat";
export const EVENT_ACCURACY_FIELD = "e_pos_acc";
export const EVENT_ALT_FIELD = "e_pos_alt";
export const EVENT_ALT_ACCURACY_FIELD = "e_pos_alt_acc";
export const EVENT_SPEED_FIELD = "e_pos_speed";
export const EVENT_PHOTO_COUNT_FIELD = "e_photo_cnt";
export const EVENT_COMMENT_COUNT_FIELD = "e_comment_cnt";

export const EVENT_PARAMS_FIELD = "e_parameters";

export const PARAM_ID_FIELD = "e_param_id";
export const PARAM_CLASS_FIELD = "e_param_class";
export const PARAM_SENSOR_FIELD = "e_param_sensor_id";
export const PARAM_GEN_DATE_FIELD = "e_param_gen_ts";
export const PARAM_RCV_DATE_FIELD = "e_param_rcv_ts";
export const PARAM_DATA_TYPE_FIELD = "e_param_data_type";
export const PARAM_NUMBER_FIELD = "e_param_number_value";
export const PARAM_VALUE_FIELD = "e_param_value";
export const PARAM_EVENT_ID_FIELD = "e_event_id";

export const PARAM_TYPE_PHOTO = "PHOTO";
export const PARAM_TYPE_PLACE = "PLACES";
export const PARAM_TYPE_COMMENT = "COMMENT";
export const PARAM_TYPE_PRESSURE = "PRESSURE";
export const PARAM_TYPE_POI = "POI";
export const PARAM_TYPE_WEATHER = "WEATHER";

export const CONDITION_MAPPING = {
    200: { short: "Thunderstorm", long: "thunderstorm with light rain" },
    201: { short: "Thunderstorm", long: "thunderstorm with rain" },
    202: { short: "Thunderstorm", long: "thunderstorm with heavy rain" },
    210: { short: "Thunderstorm", long: "light thunderstorm" },
    211: { short: "Thunderstorm", long: "thunderstorm" },
    212: { short: "Thunderstorm", long: "heavy thunderstorm" },
    221: { short: "Thunderstorm", long: "ragged thunderstorm" },
    230: { short: "Thunderstorm", long: "thunderstorm with light drizzle" },
    231: { short: "Thunderstorm", long: "thunderstorm with drizzle" },
    232: { short: "Thunderstorm", long: "thunderstorm with heavy drizzle" },
    300: { short: "Drizzle", long: "light intensity drizzle" },
    301: { short: "Drizzle", long: "drizzle" },
    302: { short: "Drizzle", long: "heavy intensity drizzle" },
    310: { short: "Drizzle", long: "light intensity drizzle rain" },
    311: { short: "Drizzle", long: "drizzle rain" },
    312: { short: "Drizzle", long: "heavy intensity drizzle rain" },
    313: { short: "Drizzle", long: "shower rain and drizzle" },
    314: { short: "Drizzle", long: "heavy shower rain and drizzle" },
    321: { short: "Drizzle", long: "shower drizzle" },
    500: { short: "Rain", long: "light rain" },
    501: { short: "Rain", long: "moderate rain" },
    502: { short: "Rain", long: "heavy intensity rain" },
    503: { short: "Rain", long: "very heavy rain" },
    504: { short: "Rain", long: "extreme rain" },
    511: { short: "Rain", long: "freezing rain" },
    520: { short: "Rain", long: "light intensity shower rain" },
    521: { short: "Rain", long: "shower rain" },
    522: { short: "Rain", long: "heavy intensity shower rain" },
    531: { short: "Rain", long: "ragged shower rain" },
    600: { short: "Snow", long: "light snow" },
    601: { short: "Snow", long: "Snow" },
    602: { short: "Snow", long: "Heavy snow" },
    611: { short: "Snow", long: "Sleet" },
    612: { short: "Snow", long: "Light shower sleet" },
    613: { short: "Snow", long: "Shower sleet" },
    615: { short: "Snow", long: "Light rain and snow" },
    616: { short: "Snow", long: "Rain and snow" },
    620: { short: "Snow", long: "Light shower snow" },
    621: { short: "Snow", long: "Shower snow" },
    622: { short: "Snow", long: "Heavy shower snow" },
    701: { short: "Mist", long: "mist" },
    711: { short: "Smoke", long: "Smoke" },
    721: { short: "Haze", long: "Haze" },
    731: { short: "Dust", long: "sand/ dust whirls" },
    741: { short: "Fog", long: "fog" },
    751: { short: "Sand", long: "sand" },
    761: { short: "Dust", long: "dust" },
    762: { short: "Ash", long: "volcanic ash" },
    771: { short: "Squall", long: "squalls" },
    781: { short: "Tornado", long: "tornado" },
    800: { short: "Clear", long: "clear sky" },
    801: { short: "Clouds", long: "few clouds: 11-25%" },
    802: { short: "Clouds", long: "scattered clouds: 25-50%" },
    803: { short: "Clouds", long: "broken clouds: 51-84%" },
    804: { short: "Clouds", long: "overcast clouds: 85-100%" }
};
export const FULL_DISTANCE_KM = 8578.2;
export const startFinishIcon = new L.Icon({
  iconUrl: require('../assets/images/red-dot.svg'),
  iconRetinaUrl: require('../assets/images/red-dot.svg'),
  iconSize: [50, 50],
  className: 'start-finish-icon'
});
export const currentPositionIcon = new L.Icon({
  iconUrl: require('../assets/images/bike.svg'),
  iconRetinaUrl: require('../assets/images/bike.svg'),
  iconSize: [40, 40]
});